"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonCatalogueDesktop = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styles = require("../../BurgerMenu/Catalogues/styles");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const CatalogueSkeleton = (0, _mui.styled)(_presentationComponents.CategoryBoxSkeleton)({
  width: _presentationComponents.CATEGORY_BOX_DESKTOP_MEDIUM_WIDTH
});
const ButtonSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  borderRadius: theme.spacing(5),
  marginTop: theme.spacing(2)
}));
const SkeletonCatalogueDesktop = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.SKELETON_CATALOGUE_DESKTOP),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CatalogueWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CatalogueSkeleton, {
        showDescription: true
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CallToActionWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        variant: "text",
        height: 30,
        width: 330
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        variant: "text",
        height: 30,
        width: 330
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonSkeleton, {
        variant: "rectangular",
        height: 45,
        width: 330
      })]
    })]
  });
};
exports.SkeletonCatalogueDesktop = SkeletonCatalogueDesktop;
